import {createContext} from "react";

const FilterContext = createContext({
    filter: null,
    setFilter: () => {}
});

export default FilterContext